import { BaseModel } from '../../../shared/base/base.models';
import { User } from '../users/users.models';

export class PromotionalCodeDocument extends BaseModel {
    documentNumber?: string;
    promotionalCodes?: PromotionalCode[] = [];
}

export class PromotionalCode extends BaseModel {
    code?: string;
    maxUseNumber?: number;
    timesUsed?: number;
    promotionalCodeUser?: string | User;
    userNotified?: boolean = false;
}